 
import dynamic from 'next/dynamic';

export default {
  BreadCrumbs: dynamic(() => import('@sitecore/components/content/Breadcrumbs/Breadcrumbs')),
  Chat: dynamic(() => import('@apps/chat/shared/multilabel/src/Chat')),
  CookieWall: dynamic(() => import('@apps/cookiewall/nl/multilabel/src/CookieWall')),
  Mandate: dynamic(() => import('@apps/mandate/nl/multilabel/src/Mandate')),
  Footer: dynamic(() => import('@sitecore/components/oxxio/Footer/Footer')),
  FooterMenu: dynamic(() => import('@sitecore/components/oxxio/Footer/FooterMenu')),
  SubFooterMenu: dynamic(() => import('@sitecore/components/oxxio/Footer/SubFooterMenu')),
  SocialMediaMenu: dynamic(() => import('@sitecore/components/oxxio/Footer/SocialMediaMenu')),
  ErrorPage: dynamic(() => import('@sitecore/components/content/ErrorPage/ErrorPage')),
  Accordion: dynamic(() => import('@sitecore/components/content/Accordion/Accordion')),
  GTM: dynamic(() => import('@apps/gtm/shared/multilabel/src')),
  MetaData: dynamic(() => import('@sitecore/components/system/MetaData/MetaData')),
  MetaTags: dynamic(() => import('@sitecore/components/system/MetaTags/MetaTags')),
  StructuredDataSchema: dynamic(() => import('@sitecore/components/system/StructuredDataSchema/StructuredDataSchema')),
  MainNavigation: dynamic(() => import('@apps/header/shared/multilabel/src/Header')),
  LanguageSelector: dynamic(() => import('@sitecore/components/content/LanguageSelector/LanguageSelector')),
  Logo: dynamic(() => import('@sitecore/components/oxxio/ImageLink/ImageLink')),

  DashboardV2: dynamic(() => import('@apps/dashboard/nl/multilabel/src/components/Dashboard/Dashboard')),
  DashboardAccountCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/DashboardAccountCard/DashboardAccountCard'),
  ),
  DynamicPricingTariffs: dynamic(
    () => import('@apps/dynamicpricingtariffs/shared/multilabel/src/DynamicPricingTariffs/DynamicPricingTariffs'),
  ),
  DynamicPriceCardElectricityV2: dynamic(
    () => import('@sitecore/components/content/DynamicPriceCard/DynamicPriceCardElectricityV2'),
  ),
  DynamicPriceCardGasV2: dynamic(() => import('@sitecore/components/content/DynamicPriceCard/DynamicPriceCardGasV2')),
  AdvancePaymentAmountCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/AdvancePaymentAmountCard/AdvancePaymentAmountCard'),
  ),

  HomeProfileCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/HomeProfileCard/HomeProfileCard'),
  ),
  InvoicesCard: dynamic(() => import('@apps/dashboard/nl/multilabel/src/components/InvoicesCard/InvoicesCard')),
  MandateCard: dynamic(() => import('@apps/dashboard/nl/multilabel/src/components/MandateCard/MandateCard')),
  MeterInErrorCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/MeterInErrorCard/MeterInErrorCard'),
  ),
  MeterreadingsCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/MeterreadingsCard/MeterreadingsCard'),
  ),
  PaymentPlanCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/PaymentPlanCard/PaymentPlanCard'),
  ),
  ContractRenewedCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/ContractRenewedCard/ContractRenewedCard'),
  ),
  PromotionCard: dynamic(() => import('@apps/dashboard/nl/multilabel/src/components/PromotionCard/PromotionCard')),
  RelocationCard: dynamic(() => import('@apps/dashboard/nl/multilabel/src/components/RelocationCard/RelocationCard')),
  ServiceLinksCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/ServiceLinksCard/ServiceLinksCard'),
  ),
  UsageCard: dynamic(() => import('@apps/dashboard/nl/multilabel/src/components/UsageCard/UsageCard')),

  OutstandingInvoices: dynamic(
    () => import('@apps/invoices/shared/multilabel/src/components/OutstandingInvoices/OutstandingInvoices'),
  ),
  PayAllInvoicesV2: dynamic(
    () => import('@apps/invoices/shared/multilabel/src/components/PayAllInvoices/PayAllInvoices'),
  ),
  PartialPaymentInvoicesV2: dynamic(
    () => import('@apps/invoices/shared/multilabel/src/components/PartialPaymentInvoices/PartialPaymentInvoices'),
  ),
  OverviewInvoices: dynamic(
    () => import('@apps/invoices/shared/multilabel/src/components/OverviewInvoices/OverviewInvoices'),
  ),
  IntroductionCard: dynamic(
    () => import('@apps/dashboard/nl/multilabel/src/components/IntroductionCard/IntroductionCard'),
  ),
  InvoiceDetailV2: dynamic(() => import('@apps/invoices/shared/multilabel/src/components/InvoiceDetail/InvoiceDetail')),
  SideNav: dynamic(() => import('@sitecore/components/content/SideNav/SideNav')),
  PaymentPlan: dynamic(() => import('@apps/profile/nl/multilabel/src/PaymentPlanCard/PaymentPlanCard')),
  PaymentPlanForm: dynamic(() => import('@apps/profile/nl/multilabel/src/PaymentPlanForm/PaymentPlanForm')),

  ContactPreferencesForm: dynamic(
    () => import('@apps/profile/nl/multilabel/src/ContactPreferencesForm/ContactPreferencesForm'),
  ),
  CorrespondenceAddress: dynamic(
    () => import('@apps/profile/nl/multilabel/src/CorrespondenceAddressCard/CorrespondenceAddressCard'),
  ),
  CorrespondenceAddressForm: dynamic(
    () => import('@apps/profile/nl/multilabel/src/CorrespondenceAddressForm/CorrespondenceAddressForm'),
  ),
  SmartMeterSettings: dynamic(
    () => import('@apps/profile/nl/multilabel/src/Privacy/SmartMeterSettingsCard/SmartMeterSettingsCard'),
  ),
  SmartMeterSettingsForm: dynamic(
    () => import('@apps/profile/nl/multilabel/src/Privacy/SmartMeterSettingsForm/SmartMeterSettingsForm'),
  ),
  ConsentSettings: dynamic(
    () => import('@apps/profile/nl/multilabel/src/Privacy/ConsentSettingsCard/ConsentSettingsCard'),
  ),
  ConsentSettingsForm: dynamic(
    () => import('@apps/profile/nl/multilabel/src/Privacy/ConsentSettingsForm/ConsentSettingsForm'),
  ),
  IsmaSettings: dynamic(() => import('@apps/profile/nl/multilabel/src/Privacy/IsmaSettingsCard/IsmaSettingsCard')),
  IsmaSettingsForm: dynamic(() => import('@apps/profile/nl/multilabel/src/Privacy/IsmaSettingsForm/IsmaSettingsForm')),
  GdprCard: dynamic(() => import('@apps/profile/nl/multilabel/src/Privacy/GdprCard/GdprCard')),
  HomeProfile: dynamic(() => import('@apps/profile/nl/multilabel/src/HomeProfileCard/HomeProfileCard')),
  HomeProfileForm: dynamic(() => import('@apps/profile/nl/multilabel/src/HomeProfileForm/HomeProfileForm')),
  MonthlyEnergyReport: dynamic(
    () => import('@apps/profile/shared/multilabel/src/MonthlyEnergyReport/MonthlyEnergyReport'),
  ),
  // Track & Trace
  OrdersDashboard: dynamic(() => import('@apps/orders/nl/multilabel/src/OrdersDashboard')),
  Orders: dynamic(() => import('@apps/orders/nl/multilabel/src')),

  ProductsV2: dynamic(() => import('@apps/products/shared/multilabel/v2/src/Products')),
  DownloadContracts: dynamic(() => import('@sitecore/components/content/DownloadContracts/DownloadContracts')),
  ProductsNavigation: dynamic(() => import('@apps/products/shared/multilabel/v2/src/ProductsNavigation')),
  PersonalDetails: dynamic(() => import('@apps/profile/shared/multilabel/src/PersonalDetails/PersonalDetails')),
  PersonalDetailsForm: dynamic(() => import('@apps/profile/nl/multilabel/src/PersonalDetailsForm/PersonalDetailsForm')),
  AdvancePaymentAmount: dynamic(() => import('@apps/advancepayment/nl/multilabel/src/AdvancePaymentAmount')),
  AdvancePaymentAmountForm: dynamic(() => import('@apps/advancepayment/nl/multilabel/src/AdvancePaymentAmountForm')),
  NotificationsBar: dynamic(() => import('@sitecore/components/content/NotificationsBar/NotificationsBar')),
  NotificationBox: dynamic(() => import('@sitecore/components/content/NotificationBox/NotificationBox')),
  UsernameDetailsCard: dynamic(
    () => import('@apps/profile/shared/multilabel/src/UsernameDetailsCard/UsernameDetailsCard'),
  ),
  PasswordDetailsCard: dynamic(
    () => import('@apps/profile/shared/multilabel/src/PasswordDetailsCard/PasswordDetailsCard'),
  ),
  UsernameDetailsForm: dynamic(
    () => import('@apps/profile/shared/multilabel/src//UsernameDetailsForm/UsernameDetailsForm'),
  ),
  PasswordDetailsForm: dynamic(
    () => import('@apps/profile/shared/multilabel/src/PasswordDetailsForm/PasswordDetailsForm'),
  ),
  PaymentArrangement: dynamic(
    () => import('@apps/paymentarrangement/nl/multilabel/src/PaymentArrangement/PaymentArrangement'),
  ),
  PaymentArrangementTransactionV2: dynamic(
    () =>
      import('@apps/paymentarrangement/nl/multilabel/src/PaymentArrangementTransaction/PaymentArrangementTransaction'),
  ),
  'payment-arrangement-flow': dynamic(
    () => import('@apps/paymentarrangement/nl/multilabel/src/PaymentArrangementFlow/PaymentArrangementFlow'),
  ),
  PaymentTransactionStatusV2: dynamic(
    () => import('@apps/payment/shared/multilabel/src/PaymentTransactionStatus/PaymentTransactionStatus'),
  ),
  'relocation-flow': dynamic(() => import('@apps/relocation/nl/multilabel/src/RelocationFlow/RelocationFlow')),
  RelocationProcessing: dynamic(
    () => import('@apps/relocation/nl/multilabel/src/RelocationFile/Processing/Processing'),
  ),
  RelocationMoveInCard: dynamic(
    () => import('@apps/relocation/nl/multilabel/src/RelocationFile/MoveInCard/MoveInCard'),
  ),
  RelocationMoveOutCard: dynamic(
    () => import('@apps/relocation/nl/multilabel/src/RelocationFile/MoveOutCard/MoveOutCard'),
  ),
  RelocationMoveInForm: dynamic(
    () => import('@apps/relocation/nl/multilabel/src/RelocationFile/MoveInForm/MoveInForm'),
  ),
  RelocationMoveOutForm: dynamic(
    () => import('@apps/relocation/nl/multilabel/src/RelocationFile/MoveOutForm/MoveOutForm'),
  ),
  RelocationProductsCard: dynamic(
    () => import('@apps/relocation/nl/multilabel/src/RelocationFile/ProductsCard/ProductsCard'),
  ),
  QuickLinks: dynamic(() => import('@sitecore/components/content/QuickLinks/QuickLinks')),

  // MOVEOUT FLOW
  'move-out-flow': dynamic(() => import('@apps/relocation/nl/multilabel/src/MoveOutFlow/MoveOutFlow')),

  // USAGE
  Usage: dynamic(() => import('@apps/usage/nl/multilabel/v1/src/Usage/Usage')),
  UsageV2: dynamic(() => import('@apps/usage/nl/multilabel/v2/src/Usage/Usage')),
  UsageCapYearnoteView: dynamic(() => import('@apps/usagecap/shared/multilabel/src/yearnoteView/YearnoteView')),
  UsageCapMonthView: dynamic(() => import('@apps/usagecap/shared/multilabel/src/monthView/MonthView')),

  // GENERAL/CUSTOM/CONTENT COMPONENTS
  AccountCard: dynamic(() => import('@components-next/AccountCard/AccountCard')),
  NextBestActionBanner: dynamic(() => import('@components/NextBestActionBanner/NextBestActionBanner')),

  UsabillaFeedback: dynamic(() => import('@sitecore/components/system/UsabillaFeedback/UsabillaFeedback')),
  ChatLinks: dynamic(() => import('@sitecore/components/content/ChatLinks/ChatLinks')),
  MegaMenu: dynamic(() => import('@sitecore/components/content/MegaMenu/MegaMenu')),
  MegaMenuV2: dynamic(() => import('@sitecore/components/content/MegaMenuV2/MegaMenuV2')),
  MegaMenuDivision: dynamic(() => import('@sitecore/components/content/MegaMenuDivision/MegaMenuDivision')),
  Image: dynamic(() => import('@sitecore/components/content/Image/Image')),
  MessageBar: dynamic(() => import('@sitecore/components/content/MessageBar/MessageBar')),

  // Wrappable components
  Bucket: dynamic(() => import('@sitecore/components/content/Bucket/Bucket')),
  TopTaskCTA: dynamic(() => import('@sitecore/components/content/TopTaskCTA/TopTaskCTA')),
  TitleTextCTA: dynamic(() => import('@sitecore/components/content/TitleTextCTA/TitleTextCTA')),
  PersonalizedTitleTextCTA: dynamic(
    () => import('@sitecore/components/content/PersonalizedTitleTextCTA/PersonalizedTitleTextCTA'),
  ),
  Checklist: dynamic(() => import('@sitecore/components/content/Checklist/Checklist')),

  // Wrapper components
  Section: dynamic(() => import('@sitecore/components/content/Section/Section')),
  SplitView: dynamic(() => import('@sitecore/components/content/SplitView/SplitView')),
  Centered: dynamic(() => import('@sitecore/components/content/Centered/Centered')),
};
